import React from "react";

const AvatarBlock = ({ avatar, initials, online, name }) => (
  <div className="qp-avatar-wrap">
    {avatar ? (
      <img
        src={avatar}
        alt={name}
        className="qp-avatar"
        onError={(e) => {
          e.currentTarget.style.display = "none";
          const placeholder = e.currentTarget.nextSibling;
          if (placeholder) placeholder.style.display = "flex";
        }}
      />
    ) : null}
    <div
      className="qp-avatar-placeholder"
      style={{ display: avatar ? "none" : "flex" }}
    >
      {initials}
    </div>
    {online && <span className="qp-online-dot" />}
  </div>
);

export default AvatarBlock;

